import type { SocialHomeBanner } from "@core/home/types";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { A11y, Autoplay, Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { CampaignVisual } from "./CampaignVisual";

type CampaignSliderProps = {
  banners: SocialHomeBanner[];
  canCycle: boolean;
};

export function CampaignSlider({ banners, canCycle }: CampaignSliderProps) {
  if (banners.length === 0) return null;

  return (
    <Swiper
      modules={[A11y, Autoplay, Navigation, Pagination]}
      slidesPerView={1}
      autoHeight
      observer
      observeParents
      watchOverflow
      loop={canCycle}
      autoplay={
        canCycle
          ? {
              delay: 5500,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }
          : false
      }
      navigation={canCycle}
      pagination={canCycle ? { clickable: true } : false}
      className="group/campaign-slider w-full overflow-hidden [&_.swiper-button-next]:!hidden [&_.swiper-button-next]:!size-11 [&_.swiper-button-next]:!rounded-full [&_.swiper-button-next]:!border [&_.swiper-button-next]:!border-white/40 [&_.swiper-button-next]:!bg-slate-950/75 [&_.swiper-button-next]:!text-white [&_.swiper-button-next]:!shadow-lg [&_.swiper-button-next]:backdrop-blur-sm [&_.swiper-button-next]:after:!text-base [&_.swiper-button-next]:after:!font-bold [&_.swiper-button-prev]:!hidden [&_.swiper-button-prev]:!size-11 [&_.swiper-button-prev]:!rounded-full [&_.swiper-button-prev]:!border [&_.swiper-button-prev]:!border-white/40 [&_.swiper-button-prev]:!bg-slate-950/75 [&_.swiper-button-prev]:!text-white [&_.swiper-button-prev]:!shadow-lg [&_.swiper-button-prev]:backdrop-blur-sm [&_.swiper-button-prev]:after:!text-base [&_.swiper-button-prev]:after:!font-bold [&_.swiper-pagination-bullet-active]:!w-6 [&_.swiper-pagination-bullet-active]:!bg-violet-600 [&_.swiper-pagination-bullet-active]:!opacity-100 [&_.swiper-pagination-bullet]:!m-0 [&_.swiper-pagination-bullet]:!size-2.5 [&_.swiper-pagination-bullet]:!bg-slate-700 [&_.swiper-pagination-bullet]:!opacity-55 [&_.swiper-pagination-bullet]:!transition-all [&_.swiper-pagination]:!bottom-3 [&_.swiper-pagination]:!start-1/2 [&_.swiper-pagination]:!z-20 [&_.swiper-pagination]:!flex [&_.swiper-pagination]:!w-auto [&_.swiper-pagination]:!-translate-x-1/2 [&_.swiper-pagination]:!items-center [&_.swiper-pagination]:!gap-1.5 [&_.swiper-pagination]:!rounded-full [&_.swiper-pagination]:!border [&_.swiper-pagination]:!border-white/80 [&_.swiper-pagination]:!bg-white/90 [&_.swiper-pagination]:!px-2.5 [&_.swiper-pagination]:!py-1.5 [&_.swiper-pagination]:!shadow-md [&_.swiper-pagination]:backdrop-blur-sm md:[&_.swiper-button-next]:!flex md:[&_.swiper-button-prev]:!flex"
    >
      {banners.map((banner) => (
        <SwiperSlide key={banner.id} className="!h-auto">
          <CampaignVisual banner={banner} />
        </SwiperSlide>
      ))}
    </Swiper>
  );
}
